import { getUrlParam } from '@/utils/util';

export const Mixin = {
  data() {
    return {
      active: 0,
      getCustomerCompanyInfoList: [],
      getCustomerAppInfoList: [],
      isSpinning: false,
      companyInfo: {
        companyName: '',
        companyCode: '',
        appUrl: '',
      },
      toLoginFlag: '',
    };
  },
  computed: {
    VUE_APP_LOGO() {
      return '/weiit_logo.png';
    },
    hasStore() {
      return this.getCustomerAppInfoList && this.getCustomerAppInfoList.some(item => item.appName == '门店');
    },
    hasMall() {
      return this.getCustomerAppInfoList && this.getCustomerAppInfoList.some(item => item.appName == '商城');
    },
  },

  methods: {
    async initData(callback) {
      try {
        await this.getCustomerCompanyInfo();
        await this.getCustomerAppInfo();
        if (callback) callback();
      } catch (error) {
        console.error('initData error:', error);
        this.spinning = false;
      }
    },
    getToken() {
      if (getUrlParam('token')) {
        localStorage.setItem('token', getUrlParam('token'));
        history.pushState({}, 0, this.delUrlParam('token'));
      } else {
        if (!localStorage.getItem('token')) {
          location.href = process.env.VUE_APP_LOGIN_BASE_URL;
        }
      }
    },
    getUrl(hasType, type) {
      let info = this.getCustomerAppInfoList.find(item => type == item.appName);
      if (!info) return '';
      let url = info.appUrl.replace('#rcsToken#', info.ticket).replace('#tenantId#', info.tenantId);
      if (process.env.NODE_ENV == 'development') {
        switch (type) {
          case '门店':
            url = url.replace(/^https?:\/\/[^/]+/, 'http://localhost:3002');
            break;
          case '商城':
            //商城
            url = url.replace(/^https?:\/\/[^/]+/, 'http://localhost:3001');
            break;
        }
      }
      return hasType ? url : '';
    },
    toGo() {
      let url = '';
      switch (this.active) {
        case 1:
          url = this.getUrl(this.hasStore, '门店');
          url && (location.href = url);
          break;
        case 2:
          url = this.getUrl(this.hasMall, '商城');
          url && (location.href = url);
          break;
        default:
          break;
      }
    },
    //获取当前用户关联的企业列表
    async getCustomerCompanyInfo() {
      let getCustomerCompanyInfo = await this.$axios.post(this.$api.getCustomerCompanyInfo);
      this.getCustomerCompanyInfoList =
        getCustomerCompanyInfo.result && getCustomerCompanyInfo.result.length > 0 ? getCustomerCompanyInfo.result : [];
      this.companyInfo =
        getCustomerCompanyInfo.result && getCustomerCompanyInfo.result.length > 0
          ? getCustomerCompanyInfo.result[0]
          : {};
    },
    //根据企业编号获取当前用户关联的应用列表
    async getCustomerAppInfo() {
      let data = {
        companyCode: this.companyInfo.companyCode,
      };
      let getCustomerAppInfo = await this.$axios.post(this.$api.getCustomerAppInfo, data);
      this.getCustomerAppInfoList = getCustomerAppInfo.result;
      this.spinning = false;
      this.displayNone = false;
    },
  },
};
